import { useParams } from 'react-router-dom';
import BN001_IOS from '../../assets/images/cardplate/cardplate_main_AOS.png';
import BN001_AOS from '../../assets/images/cardplate/cardplate_main_iOS(2x).png';
import BN002_IOS from '../../assets/images/cardplate/cardplate_suggestion_AOS.png';
import BN002_AOS from '../../assets/images/cardplate/cardplate_suggestion_iOS(2x).png';
import { isIOS } from 'mobile-device-detect';

const useCardPlate = () => {
  const { cardplateSeq } = useParams();

  const os = isIOS ? 'ios' : 'aos';

  switch (`${cardplateSeq}/${os}`) {
    case 'BN001/ios':
      return { source: BN001_IOS, alt: '대출비교' };
    case 'BN001/aos':
      return { source: BN001_AOS, alt: '대출비교' };
    case 'BN002/ios':
      return { source: BN002_IOS, alt: '대출비교' };
    case 'BN002/aos':
      return { source: BN002_AOS, alt: '대출비교' };
  }
  return { source: '', alt: '' };
};

export default useCardPlate;
